<template>
<div id="taskSingleTree">
    <div id="pleaseSelect" v-loading="loading">
        <div class="tree-nodes" id="treeNodes">
            <ul :key="index" v-for="(item,index) in model">
                <tree ref="tree" :model="item" :index="index" :treeShow=true :transferAimFlag=transferAimFlag></tree>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import tree from "@/components/common/trees/tree";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            model: [],
            transferAimFlag: true,
            checkedNodes: '',
            loading: true,
            flag: true,
            scrollTopValue: 0,
            realTimeMode:true,
            pass:[],
        };
    },
    mounted() {
        this.refreshModel();
    },
    watch:{
    },
    methods: {
        refreshModel() {
            this.$store.commit('setClickItem', null);
            this.$store.commit('setArr', -1);
            let that = this;
            this.loading = true;
            this.model = Object.assign([], this.$store.getters.getUsersDrives).filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
            if (!this.model.length&&(that.$route.name == 'cloudTransfer'||that.$route.name=='cloudBackup'||that.$route.name=='emailTransfer')) {
                this.model = this.Utils.getAllCloudsList(function (res) {
                    if (res.status == 200) {
                        //不需要邮箱
                        that.model = that.model.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
                        that.loading = false;
                    }
                });
            } else {
                this.loading = false;
            }
            $.each(this.model, function (index, item) {
                if (item.children && item.children.length) {
                    item.open = false;
                    delete item.children;
                }
            });
        },
        taskSigleClose() {
            let that=this;
            if (!this.$store.state.clickItem || !this.$parent.singleDrives.name) {
                $.each(this.model, function (index, item) {
                    item.open = false;
                    if (item.children&&item.children.length) {
                        commonUtils.closeTree(item.children);
                    }
                });
                //  this.$nextTick(() => {
                //               that.$refs['elscrollbar'].wrap.scrollTop=0;
                // });
                // setTimeout(()=>{
                //           that.taskSingleShow= false;
                // },10);
                this.scrollTopValue = 0;
            }
        },
        refresh(){
            this.$forceUpdate();
        },
        toAddCloudPage() {
            let dom;
            let that = this;
            $.each(that.$parent.$parent.$children, function (i, item) {
                if (item.menuOptions) {
                    dom = that.$parent.$parent.$children[i];
                    dom.menuOptionSelect(901);
                    return;
                }
            });
        },
        getFilePath(json, nodes) {
            node = null;
            if (nodes == null) return "";
            let fileName = nodes.name;

            var res = this.getNode(json, nodes.id);
            var pNode = res.parentNode;
            if (pNode != null) {
                if (pNode.name != null && pNode != undefined) {
                    fileName = this.getFilePath(json, pNode) + "/" + fileName;
                }
            }
            return fileName;
        },
        singleSubmit() {
            let that = this;
            let node = this.$store.state.clickItem;
            if( this.$parent.pageName == 'cloudBackup'){
                 var driveId;
                   if(node.driveInfo && node.driveInfo.id){
                      driveId = node.driveInfo.id;
                  }else{
                      driveId = node.driveId;
                   }
                if(!this.pass.includes(driveId) &&node.afterBackup != undefined && !node.afterBackup){
                this.$parent.$refs.readdCloudDialog.nodes.push(node);
                this.$parent.$refs.readdCloudDialog.readdShow = true;
                this.$parent.$refs.readdCloudDialog.source='aim';
                 return;
                }
                if(!this.pass.includes(driveId) && node.afterBackup == undefined &&  !node.driveInfo.afterBackup){
                this.$parent.$refs.readdCloudDialog.nodes.push(node);
                this.$parent.$refs.readdCloudDialog.readdShow = true;
                this.$parent.$refs.readdCloudDialog.source='aim';
                 return;
                }

            }
            let pKey;
            if (node) {
                let type = node.driveType;
                let pathArray = taskTransferUtils.findFilePathArray(this.model, node, []);
                let path = pathArray[0];
                for (let i = 1; i < pathArray.length; i++) {
                    path = path + '\\' + pathArray[i];
                }
                node.driveType = type;
                node.cloudCatalog = path;
                let sourceCatalogArr = [];
                //判断路径是否重复 且源目录的id不能是父目录的父id
                if (this.$parent.mulitDrives&&this.$parent.mulitDrives.length) {
                    for (let i = 0; i < this.$parent.mulitDrives.length; i++) {
                        pKey = this.$parent.mulitDrives[i].keyId + this.$parent.mulitDrives[i].formUrl;
                        sourceCatalogArr.push(pKey);
                    }
                    this.flag = taskTransferUtils.checkCatalog(sourceCatalogArr, node);
                    if (this.flag == false) {
                        that.$toast({
                            text: that.$t('language.exception.notBeTheSame'),
                            type: 'fail',
                            idValue: "taskSingleTree",
                            learnMoreShow: true
                        });
                        return false;
                    }
                }

                if (this.flag) {
                    this.checkedNodes = node;
                    this.$parent.singleDrives = node; //如果父弹窗目标未包括该选项，则赋值
                    this.$parent.hasSelect = false;
                    if (!path) {
                        this.$parent.hasSelect = true;
                    }
                }
            }
        },
        singleSubmitForEmailSync(){
            let that = this;
            let node = this.$store.state.clickItem;
            let pKey;
            if (node&&node!=-1) {
                let type = node.driveType;
                let pathArray = taskTransferUtils.findFilePathArray(this.model, node, []);
                let path = pathArray[0];
                for (let i = 1; i < pathArray.length; i++) {
                    path = path + '\\' + pathArray[i];
                }
                node.driveType = type;
                node.cloudCatalog = path;
                if (this.flag) {
                    this.checkedNodes = node;
                    this.$parent.$parent.singleDrives = node; //如果父弹窗目标未包括该选项，则赋值
                    this.$parent.$parent.hasSelect = false;
                    if (!path) {
                        this.$parent.$parent.hasSelect = true;
                    }
                }
            }
        }
    },
    components: {
        tree
    }
};
</script>

<style>
.el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/common/trees/transfer_single_tree.vue